import braintreeClient from 'braintree-web/client';
import {
  uninitializedRemoteData,
  unfetchedRemoteData,
  remoteDataError,
  RemoteData,
} from '@/lib/frontend/store/helpers/remoteData';
import { Action } from '../../actions';
export type BraintreeClient = RemoteData<braintreeClient.Client>;
const defaultState = uninitializedRemoteData<braintreeClient.Client>();
export default function braintreeClientReducer(
  state: BraintreeClient = defaultState,
  action: Action,
): BraintreeClient {
  switch (action.type) {
    case 'INITIALIZE_BRAINTREE_START':
      return unfetchedRemoteData<braintreeClient.Client>();
    case 'INITIALIZE_BRAINTREE_FAIL':
      return remoteDataError<braintreeClient.Client>(action.message);
    default:
      return state;
  }
}
